'use client';

import { useMutation } from '@apollo/client/react';
import { PENDING_SAVE_RECIPE_KEY } from '@fdc/constants/recipe.constants';
import { SAVE_FAVOURITE_RECIPE } from '@fdc/federation/nz/mutations/save-favourite-recipe';
import { useAuth } from '@fdc/hooks/useAuth';

export const useSaveFavouriteRecipe = () => {
  const { isAuthenticated, redirectToLogin } = useAuth();

  const [saveFavouriteRecipe, { loading, error }] = useMutation(
    SAVE_FAVOURITE_RECIPE
  );

  const handleSaveFavouriteRecipe = (recipeId: string) => {
    if (!isAuthenticated) {
      sessionStorage.setItem(PENDING_SAVE_RECIPE_KEY, recipeId);
      redirectToLogin();
      return;
    }

    return saveFavouriteRecipe({
      variables: {
        input: { recipeId },
      },
    });
  };

  return {
    handleSaveFavouriteRecipe,
    loading,
    error,
  };
};
